export const regexValidator = {
  onlyNumber: /^[0-9]*$/,
  emailBueEdu: /^[A-Za-z0-9._%+-]+@bue.edu.ar$/
};
